
import React, { useEffect, useRef, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Nav, Card } from "react-bootstrap";
import { ExclamationTriangleFill, Trash } from "react-bootstrap-icons";
import api from "../jsx/axiosClient";

// import { Trash } from "react-bootstrap-icons";
import { Tabs, Tab } from "react-bootstrap";
import { Row, Col } from "react-bootstrap";
import AudioDescriptionEdit from "../components/AudioDescriptionEdit";
import ExpertAudioRedescribe from "../components/ExpertAudioRedescribe";
import { UserContext } from "../jsx/UserContext";

import "../css/main.css";

const ExpertAudioRedescribeVideo = ({
  videoname, setVideoname,
  video,
  originalVideoUrl,
  activeTab,
  setActiveTab,
  videoRef,
  //isExpert ,

  videoDescription, setVideoDescription,
  model, setModel,
  language, setLanguage,
  descriptionType, setDescriptionType,
  voice, setVoice,
  mediaFormats, mediaFormatError,
  toggleFormat,
  handleRedescribe,
  isRedescribing,
  progress,
  handleExport,
  redescribeVideodetails,
}) => {
  const descriptionRef = useRef(null);
  const [editingIndex, setEditingIndex] = React.useState(null);
  const [editedText, setEditedText] = React.useState("");
  const [showEditModal, setShowEditModal] = React.useState(false);
  const [selectedItem, setSelectedItem] = React.useState(null);
  const [editText, setEditText] = React.useState("");
  const [editStart, setEditStart] = React.useState("");
  const [editEnd, setEditEnd] = React.useState("");
  const [isSaving, setIsSaving] = React.useState(false);
  const [toast, setToast] = React.useState({ show: false, message: "", variant: "success" });
  const [showDeleteModal, setShowDeleteModal] = React.useState(false);
  const [deleteItem, setDeleteItem] = React.useState(null);
  const [isDeleting, setIsDeleting] = React.useState(false);
  const { userSession } = useContext(UserContext); // âœ… get token from context
const descriptions = video?.descriptions || [];

// descriptions.map((item, index) => {
//   console.log("Split ID:", item.id);   // ✅ THIS is what backend sent

//   return null;
// });
  const navigate = useNavigate();
  // -----------------------------
  // Auto-scroll + highlight logic
  // -----------------------------
  const scrollToCurrent = (ts) => {
    const items = descriptionRef.current.querySelectorAll(".desc-card");

    items.forEach((item) => item.classList.remove("active-desc"));

    const active = Array.from(items).find((x) => x.dataset.ts === ts);
    if (active) {
      active.classList.add("active-desc");
      active.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };
  const showToast = (message, variant = "success") => {
    setToast({ show: true, message, variant });
    setTimeout(() => setToast({ show: false, message: "", variant }), 3000);
  };
  // const isOverlapping = (start, end, currentIndex) => {
    const isOverlapping = (start, currentIndex) => {
    const startSec = tsToSeconds(start);
    // const endSec = tsToSeconds(end);

    // return buildFinalTimeline(video.descriptions).some((item, idx) => {
    //   if (item.index === currentIndex) return false;

    //   const itemStart = item.audio_start;
    //   const nextItem = video.descriptions[item.index + 1];
    //   const itemEnd = nextItem ? nextItem.end : item.audio_start + 2;

    //   return (
    //     startSec < itemEnd &&
    //     endSec > itemStart
    //   );
    // });
return buildFinalTimeline(video.descriptions).some((item) => {
  if (item.index === currentIndex) return false;

  return Math.abs(startSec - item.audio_start) < 1; // prevent same/close timestamps
});
  };


  const handleSaveEdit = async () => {
    if (!selectedItem) return;

    const startSec = tsToSeconds(editStart);
    // const endSec = tsToSeconds(editEnd);

    // if (isNaN(startSec) || isNaN(endSec) || endSec <= startSec) {
    //   showToast("Invalid time range", "danger");
    //   return;
    // }

    // if (isOverlapping(editStart, editEnd, selectedItem.index)) {
    //   showToast("Time interval overlaps with another description", "danger");
    //   return;
    // }

if (isNaN(startSec)) {
  showToast("Invalid start time", "danger");
  return;
}
if (isOverlapping(editStart, selectedItem.index)){
      showToast("Time interval overlaps with another description", "danger");
      return;
}
    try {
      setIsSaving(true);


    const formData = new FormData();
 formData.append("video_id", video.id);
    formData.append("caption", editText);
    formData.append("edited_by", "expert");
    formData.append("reason", "edit");
    formData.append("split_id", selectedItem.split_id);
    // formData.append("start_time", editStart);
    // formData.append("end_time", editEnd);

        console.log("Expert FormData contents:");
        for (let [key, val] of formData.entries()) {
            console.log(key, val);
        }

        const res = await api.post("/videos/edit-description", formData, {
        headers: {
          Authorization: `Bearer ${userSession.access_token}`,
        },
        withCredentials: true,
      });

            const result = res.data;
            console.log("expert edit response",result)


      // if (!res.ok) throw new Error("Update failed");
if (result.status === "success") {

   showToast("Description updated successfully", "success");
      setShowEditModal(false);

      setTimeout(() => {
        window.location.reload();
      }, 800);
}else{
        showToast("Update failed", "danger");

}
   

    } catch (err) {
      console.error(err);
      showToast("Failed to save changes", "danger");
    } finally {
      setIsSaving(false);
    }
  };

  // -----------------------------------------------
  // NEW: Convert HH:MM:SS.xx → seconds (any format)
  // -----------------------------------------------
  const tsToSeconds = (ts) => {
  
    const parts = ts.split(":"); // ["00","00","05.87"]

    if (parts.length === 3) {
      const h = Number(parts[0]);
      const m = Number(parts[1]);
      const s = Number(parts[2]);
      return h * 3600 + m * 60 + s;
    }

    if (parts.length === 2) {
      const m = Number(parts[0]);
      const s = Number(parts[1]);
      return m * 60 + s;
    }

    return Number(ts);
  };



  // const buildFinalTimeline = (descriptions = []) => {
  //   const finalTimeline = [];
  //   let cumulativeOffset = 0.0;

  //   descriptions.forEach((d, index) => {
  //     const origEnd = d.end;
  //     const audioDur = d.duration ?? 0;

  //     const finalEnd = origEnd + cumulativeOffset;

  //     const audioStart = finalEnd;

  //     finalTimeline.push({
  //       index,
  //       audio_start: audioStart,
  //       caption: d.caption,
  //     });

  //     cumulativeOffset += audioDur;
  //   });

  //   return finalTimeline;
  // };

  const buildFinalTimeline = (descriptions = []) => {
    console.log("buildFinalTimeline,",descriptions)
  const finalTimeline = [];
  let cumulativeOffset = 0.0;

  descriptions.forEach((d, index) => {
    const origEnd = d.end;
    const audioDur = d.duration ?? 0;

    const finalEnd = origEnd + cumulativeOffset;
    const audioStart = finalEnd;

    finalTimeline.push({
      index,                 // UI index
      audio_start: audioStart,
      caption: d.caption,
      split_id: d.id,       
    });

    cumulativeOffset += audioDur;
  });

  return finalTimeline;
};

  const onTimeUpdate = () => {
    if (!videoRef.current || !video?.descriptions) return;

    const current = videoRef.current.currentTime;
    const timeline = buildFinalTimeline(video.descriptions);

    timeline.forEach((item) => {
      const ts = new Date(item.audio_start * 1000)
        .toISOString()
        .substring(11, 19); // ✅ SAME FORMAT

      if (
        current >= item.audio_start - 0.5 &&
        current <= item.audio_start + 0.5
      ) {
        scrollToCurrent(ts);
      }
    });
  };

  useEffect(() => {
    if (!videoRef?.current) return;
    videoRef.current.ontimeupdate = onTimeUpdate;
  }, [videoRef, video]);

  const jumpTo = (ts) => {
    if (!videoRef.current) return;
    const s = tsToSeconds(ts);
    videoRef.current.currentTime = s;
    videoRef.current.play();
  };

  const confirmDeleteDescription = async () => {
    console.log("deleteItem",deleteItem)
    if (!deleteItem) return;

    try {
      setIsDeleting(true);

    const formData = new FormData();
 formData.append("video_id", video.id);
     formData.append("split_id", deleteItem.split_id);
    formData.append("edited_by", "expert");
    formData.append("reason", "edit");
        console.log("Expert DELETE FormData contents:");
        for (let [key, val] of formData.entries()) {
            console.log(key, val);
        }

        const res = await api.post("/videos/delete-description", formData, {
        headers: {
          Authorization: `Bearer ${userSession.access_token}`,
        },
        withCredentials: true,
      });

            const result = res.data;
            console.log("expert DELETE response",result)


      // const res = await fetch(`/videos/delete-description${deleteItem.index}`, {
      //   method: "DELETE",
      // });

     //if (!res.ok) throw new Error("Delete failed");
if (result.status === "success") {
      showToast("Description deleted successfully", "success");
      setShowDeleteModal(false);

      setTimeout(() => {
        window.location.reload();
      }, 800);
    }
    } catch (err) {
      console.error(err);
      showToast("Failed to delete description", "danger");
    } finally {
      setIsDeleting(false);
    }
  };

  console.log("video in audioredwscribevideo page,", video)
  return (

    <div>
      <h2 id="formHeading" className="sr-only">
        Audio description settings
      </h2>
      <ExpertAudioRedescribe
        videoname={videoname}
        setVideoname={setVideoname}
        videoDescription={videoDescription}
        setVideoDescription={setVideoDescription}
        model={model}
        setModel={setModel}
        language={language}
        setLanguage={setLanguage}
        descriptionType={descriptionType}
        setDescriptionType={setDescriptionType}
        voice={voice}
        setVoice={setVoice}
        mediaFormats={mediaFormats}
        mediaFormatError={mediaFormatError}
        toggleFormat={toggleFormat}
        handleRedescribe={handleRedescribe}
        isRedescribing={isRedescribing}
        progress={progress}
        handleExport={handleExport}
        redescribeVideodetails={redescribeVideodetails}
        video={video}
        videoRef={videoRef}
      />
      <Row className="mt-3">
        <Col md={8}>
          <Card
            className="video-card shadow-sm border-0 h-100"
            role="region"
            aria-labelledby="video-title"
          >
            <div
              className="video-title-videodiv"
              id="video-title"
              aria-live="polite"
            >
              {videoname}
            </div>

            <Nav
              variant="pills"
              activeKey={activeTab}
              onSelect={(key) => setActiveTab(key)}
              className="video-tabs"
              role="tablist"
              aria-label="Video type tabs"
            >
              <Nav.Item>
                <Nav.Link
                  eventKey="described"
                  disabled={!video?.output_download_url}
                  role="tab"
                >
                  Audio Described
                  {video?.video_status === "in progress" && (
                    <i className="bi bi-hourglass-split ms-1 text-warning" />
                  )}
                  {video?.video_status === "failed" && (
                    <ExclamationTriangleFill
                      size={14}
                      color="red"
                      className="ms-1"
                    />
                  )}
                </Nav.Link>
              </Nav.Item>

              <Nav.Item>
                <Nav.Link eventKey="original" role="tab">
                  Original Video
                </Nav.Link>
              </Nav.Item>
            </Nav>

            {activeTab === "described" && video?.output_download_url && (
              <div role="tabpanel">
                <video
                  ref={videoRef}
                  src={video.output_download_url}
                  controls
                  className="video-player"
                />

                <AudioDescriptionEdit
                  videoRef={videoRef}
                  videoSrc={video.output_download_url}
                  videoDescription={videoDescription}
                />
              </div>
            )}

            {activeTab === "original" && originalVideoUrl && (
              <div role="tabpanel">
                <video
                  ref={videoRef}
                  src={originalVideoUrl}
                  controls
                  className="video-player"
                />
              </div>
            )}

          </Card>
        </Col>

        <Col md={4}>
          <Card
            className="shadow-sm border-0 h-100"
            role="region"
            aria-label="Description timeline card"
          >

            <div
              ref={descriptionRef}
              className="description-box-expert"
              role="list"
              aria-label="Description Timeline"
            >

              <div className="timeline-header">
                Description Timeline
              </div>

              {video?.output_download_url &&
                video?.descriptions?.length > 0 &&
                buildFinalTimeline(video.descriptions)
                  .filter(item => item.caption?.trim())
                  .map((item, idx) => {

                    const startTime = new Date(item.audio_start * 1000)
                      .toISOString()
                      .substring(11, 19);

                    // const nextItem = video.descriptions[idx + 1];
                    // const endSeconds = nextItem
                    //   ? nextItem.end
                    //   : item.audio_start + 2;

                    // const endTime = new Date(endSeconds * 1000)
                    //   .toISOString()
                    //   .substring(11, 19);


                    return (
                      <div
                        key={item.index}
                        className="desc-card"
                        data-ts={startTime}
                        onClick={() => jumpTo(startTime)}
                        role="listitem"
                        tabIndex={0}
                      >

                        {/* <div className="desc-time-range">
                          {startTime} – {endTime}
                        </div> */}
                      <div className="desc-time-range">
                          {startTime} 
                        </div>
                        <div className="desc-text">
                          {item.caption}
                        </div>

                        <div className="desc-actions-text">
                          <span
                            className="action-link edit"

                            onClick={(e) => {
                              e.stopPropagation();

                              const startTime = new Date(item.audio_start * 1000)
                                .toISOString()
                                .substring(11, 19);

                              // const nextItem = video?.descriptions?.[item.index + 1];
                              // const endSeconds = nextItem ? nextItem.end : item.audio_start + 2;

                              // const endTime = new Date(endSeconds * 1000)
                              //   .toISOString()
                              //   .substring(11, 19);

                              setSelectedItem(item);
                              setEditText(item.caption);
                              setEditStart(startTime);
                              // setEditEnd(endTime);
                              setShowEditModal(true);
                            }}
                          >
                            <i className="bi bi-pencil me-1"></i> Edit
                          </span>

                          <span
                            className="action-link delete"
                            onClick={(e) => {
                              e.stopPropagation();
                              setDeleteItem(item);
                              setShowDeleteModal(true);
                            }}
                            title="Delete"
                            aria-label="Delete description"
                          >
                            <i className="bi bi-trash me-1"></i> Delete
                          </span>
                        </div>
                      </div>
                    );
                  })}
            </div>
          </Card>
        </Col>

      </Row>

      {showEditModal && (
        <div className="modal fade show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">

              <div className="modal-header">
                <h5 className="modal-title">Edit Description</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowEditModal(false)}
                />
              </div>

              <div className="modal-body">

                <div className="mb-3">
                  <label className="form-label">Start Time (HH:MM:SS)</label>

                  <input
                    type="text"
                    className="form-control"
                    placeholder="HH:MM:SS"
                    value={editStart}
                    // onChange={(e) => setEditStart(e.target.value)} // disbale for editing
                  />
                </div>

                {/* <div className="mb-3">
                  <label className="form-label">End Time (HH:MM:SS)</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="HH:MM:SS"
                    value={editEnd}
                    // onChange={(e) => setEditEnd(e.target.value)}
                  />
                </div> */}

                <div className="mb-3">
                  <label className="form-label">Description Text</label>
                  <textarea
                    rows="4"
                    className="form-control"
                    value={editText}
                    onChange={(e) => setEditText(e.target.value)}
                  />
                </div>

              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowEditModal(false)}
                  disabled={isSaving}
                >
                  Cancel
                </button>

                <button
                  className="btn btn-primary"
                  onClick={handleSaveEdit}
                  disabled={isSaving}
                >
                  {isSaving ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" />
                      Saving...
                    </>
                  ) : (
                    "Save"
                  )}
                </button>

              </div>

            </div>
          </div>
        </div>
      )}

      {showDeleteModal && (
        <div className="modal fade show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">

              <div className="modal-header">
                <h5 className="modal-title text-danger">
                  <i className="bi bi-trash me-2"></i>
                  Delete Description
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowDeleteModal(false)}
                />
              </div>

              <div className="modal-body">
                <p className="mb-2">Are you sure you want to delete this description?</p>
                <div className="p-2 bg-light rounded small">
                  {deleteItem?.caption}
                </div>
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowDeleteModal(false)}
                  disabled={isDeleting}
                >
                  Cancel
                </button>

                <button
                  className="btn btn-danger"
                  onClick={confirmDeleteDescription}
                  disabled={isDeleting}
                >
                  {isDeleting ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" />
                      Deleting...
                    </>
                  ) : (
                    <>
                      <i className="bi bi-trash me-1"></i> Delete
                    </>
                  )}
                </button>
              </div>

            </div>
          </div>
        </div>
      )}


      {toast.show && (
        <>
          {/* Overlay */}
          <div
            className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-50"
            style={{ zIndex: 1055 }}
          />

          {/* Centered Toast */}
          <div
            className="position-fixed top-50 start-50 translate-middle"
            style={{ zIndex: 1060 }}
          >
            <div className={`toast show text-bg-${toast.variant} shadow-lg`}>
              <div className="d-flex align-items-center">
                <div className="toast-body fs-6 px-3 py-3">
                  {toast.message}
                </div>
                <button
                  type="button"
                  className="btn-close btn-close-white me-2 m-auto"
                  onClick={() => setToast({ ...toast, show: false })}
                />
              </div>
            </div>
          </div>
        </>
      )}

      {showDeleteModal && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-50"
          style={{ zIndex: 1050 }}
        />
      )}

    </div>


  );
};

export default ExpertAudioRedescribeVideo;


